import React, { useEffect, useState } from "react";
import Popup from "../ui/Popup";
import Menu from "../ui/Menu";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Label from "../ui/Label";
import Space from "../ui/Space";
import Divider from "../ui/Divider";
import Card from "../ui/Card";


export default function NoteIndicators(props) {

    const { callback = () => { }, route = "" } = props;


    useEffect(() => {
        const actions = [
            { key: KBD.ESCAPE, action: (e) => { callback() } },
        ];
        const cleanup = listen(route, actions, false);
        return cleanup;
    }, []);


    const drawIndicators = () => {

        return (
            <div style={{ "padding": "5px", "width": "560px" }}>
                <Card>
                    <div className="shim" />
                    <Space size={20}>
                        <div></div>
                        <Label style={{ "width": "40px", "textAlign": "center" }} className="text">^^</Label>
                        <Divider vertical />
                        <Label style={{ "textAlign": "left", "lineHeight": "18px" }}>
                            Tells BM to record sale but do not adjust OH. <br />
                            Use to sell product that never has an OH (i.e not received).
                        </Label>
                    </Space>

                    <div className="shim" /><div className="shim" />
                    <Space size={20}>
                        <div></div>
                        <Label style={{ "width": "40px", "textAlign": "center" }} className="text">//%20</Label>
                        <Divider vertical />
                        <Label style={{ "textAlign": "left", "lineHeight": "18px" }}>
                            Applies the number after the % as a discount in POS. <br /> Use to automatically discount an item
                        </Label>
                    </Space>

                    <div className="shim" /><div className="shim" />
                    <Space size={20}>
                        <div></div>
                        <Label style={{"width" : "40px", "textAlign" : "center"}}  className="text">//$5.99</Label>
                        <Divider vertical />
                        <Label style={{ "textAlign": "left", "lineHeight": "18px" }}>
                            In POS, BM uses the price after the $ instead of the regular price. <br />Used for temporary sale.
                        </Label>
                    </Space>
                    <div className="shim" /><div className="shim" />

                    <Space size={20}>
                        <div></div>
                        <Label style={{ "width": "40px", "textAlign": "center" }} className="text">//@4.99</Label>
                        <Divider vertical />
                        <Label style={{ "textAlign": "left", "lineHeight": "18px" }}>
                            In POS, the regualr price and this price will be displayed and the clerk must pick one. Used when same product has multiple prices.
                        </Label>
                    </Space>
                    <div className="shim" /><div className="shim" />

                    <Space size={20}>
                        <div></div>
                        <Label style={{ "width": "40px", "textAlign": "center" }} className="text">//?</Label>
                        <Divider vertical />
                        <Label style={{ "textAlign": "left", "lineHeight": "18px" }}>
                          Alert the user when the item is canned (e.g. to find a lost item that <br />needs a class, title, ISBN correction)
                        </Label>
                    </Space>
                    <div className="shim" /><div className="shim" />
                    <Space size={20}>
                        <div></div>
                        <Label style={{"width" : "40px", "textAlign" : "center"}}  className="text">[text]</Label>
                        <Divider vertical />
                        <Label style={{ "textAlign": "left", "lineHeight": "18px" }}>
                           2nd location. Labels will show this text next to the author
                        </Label>
                    </Space>
                    <div className="shim" />
                </Card>



            </div>
        )
    }

    return (<><Popup title={"Notes field special indicators"} width={"auto"} callback={callback} component={drawIndicators()} /></>)
}